
<span v-show="visible" class="vnode__move" :style="position" @click.stop.prevent="click">
  <el-tooltip :content="tip" placement="right">
    <i class="material-icons" v-text="icon"></i>
  </el-tooltip>
</span>
